<div class="mb-2 relative">
  <div
    class="absolute top-0 bottom-0 left-0 h-full w-1 rounded-tl-md rounded-bl-md duration-200 transition-all"
    [ngClass]="{
      'bg-gray-400': !selectedItems,
      'bg-yellow-400': selectedItems && partial,
      'bg-green-400': selectedItems && !partial,
    }"
  ></div>
  <div
    class="w-full flex justify-start items-start p-2 rounded-tl-md rounded-tr-md duration-200 transition-all"
    [ngClass]="{
      'bg-gray-100/90': !selectedItems,
      'bg-yellow-100/90': selectedItems && partial,
      'bg-green-100/90': selectedItems && !partial,
      'rounded-bl-md rounded-br-md': !show
    }"
  >
    <!-- Signo plus para mostrar la sub data -->
    <div
      class="relative flex justify-center items-center w-5 h-5 mr-2"
      [ngClass]="{
        'cursor-pointer': data[subData] ? data[subData].length > 0 : false
      }"
      (click)="show = !show"
    >
      @if(data[subData] ? data[subData].length > 0 : false) {
      <span
        class="border-l-2 border-gray-700 h-4 absolute transition-all duration-200"
        [ngClass]="{ 'rotate-90': show }"
      ></span>
      <span class="border-b-2 border-gray-700 w-4 absolute"></span>
      }
    </div>
    <div class="flex flex-col justify-center items-start">
      <label class="custom-checkbox font-bold">
        <input
          type="checkbox"
          class="hidden"
          [(ngModel)]="check"
          #checkItem
          (ngModelChange)="selectedItem(checkItem.checked)"
        />
        <span
          class="checkbox flex justify-center items-center w-5 h-5 border-primary-900 border shadow-md mr-2 transition-all duration-200"
          [ngClass]="{
            'checkbox-minus': partial,
            'checkbox-ok': check && !partial
          }"
        ></span>
        {{ returnName(data) }}
      </label>
      <!-- <input type="checkbox" class="w-5 h-5 mr-2"> -->
      @if(itemDescriptionProp) {
      <small class="pl-7 cursor-default">
        Descripción:
        {{
          data[itemDescriptionProp]
            ? data[itemDescriptionProp].trim()
              ? data[itemDescriptionProp]
              : 'Sin descripción agregada'
            : 'Sin descripción agregada'
        }}
      </small>
      } @if(data[subData] ? data[subData].length > 0 : false){
      <small>
        {{ selectedItems ? selectedItems[subData].length : 0 }} de
        {{ data[subData].length }} seleccionados
      </small>

      }
    </div>
  </div>
  <div
    class="w-full hide rounded-bl-md rounded-br-md"
    [ngClass]="{
      show: show,
      border: show,
      'border-gray-100/90': !selectedItems,
      'border-yellow-100/90': selectedItems && partial,
      'border-green-100/90': selectedItems && !partial
    }"
  >
    <div>
      <div class="px-6 pt-2">
        @for (item of data[subData]; track $index) {
        <div
          class="w-full border border-gray-200 rounded-lg hover:shadow-md transition-all duration-200 hover:border-gray-300 p-2 mb-2"
          [ngClass]="{
            'border-green-500': item['check'],
            'bg-green-100/90': item['check']
          }"
        >
          <label class="custom-checkbox font-bold">
            <input
              type="checkbox"
              [(ngModel)]="item['check']"
              #check
              class="hidden"
              (ngModelChange)="selectedSubItem(check.checked, item)"
            />
            <span
              class="checkbox flex justify-center items-center w-5 h-5 checkbox-ok border-primary-900 border shadow-md mr-2 transition-all duration-200"
            ></span>
            {{ returnName(item) }}
          </label>
          @if(subDescriptionProp) {
          <small class="pl-7 cursor-default">
            Descripción:
            {{
              item[subDescriptionProp]
                ? item[subDescriptionProp].trim()
                  ? item[subDescriptionProp]
                  : 'Sin descripción agregada'
                : 'Sin descripción agregada'
            }}
          </small>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
